import React from "react"

const ansh_mehta = () => {
    return (
        <div>
<h1>Ansh Mehta</h1>

<h4><em>Computer Engineering, Batch of 27'<br/><hr/></em></h4>

<p><strong>What was the criteria for shortlisting candidates in the initial stages of the recruitment process</strong>?<br />
Required academics to apply to HSBC was 7 CGPA and no backlogs.</p>

<p><strong>What was the Timeline of the entire Interview Process</strong>?<br />
18th August: Virtual company Presentation followed by on campus Online test<br />
22nd August: Results of the online test were announced<br />
26th August: Both technical and HR interviews conducted on the same day</p>

<p><strong>What was the Structure of the Aptitude Round?</strong><br />
The test was broken down into two Sections - Simulate assessment and codility assessment. The two combined for a total test time of around 5 hours </p>

<p>Simulate Assessment - This was the first stage of the assessment. It focussed on evaluating Logical Reasoning, Verbal Reasoning, Listening skills, Office situations, Grammar and punctuation. Relatively easy difficulty</p>

<p>Codility Assessment - The second stage of assessment. Primarily tests problem solving and coding skills. A total of 3 questions are asked - 1 easy, 1 medium question and 1 hard question.</p>

<p><strong>How many students were shortlisted after the Aptitude Round?</strong><br />
16 Students</p>

<p><strong>After being shortlisted, how long was the wait time before the interviews began? During this period, what specific areas did you focus on to prepare effectively?</strong><br />
They gave us time period of 4 days to prepare. I primarily focussed on strengthening my core concepts in OS, DBMS,  DSA, OOPS, and solving logic puzzles and scalability problems. I also reviewed all my projects and possible questions and also revised DSA problems from strivers</p>

<p><strong>How many Interview Rounds were there for the company, can you elaborate about each round in brief? Also mention, how many students were shortlisted after each Interview Round?</strong><br />
There were a total of 2 interview rounds - One was a technical round and the second was an HR round. Only candidates selected after the technical round were required to appear for the HR round. </p>

<p>Technical Round - This primarily assesses your technical skills and subject knowledge in the field of computer science and Finance.</p>

<p>HR Round - this is relatively less stressful and you are only assessed based on  behavioural aspects and whether you will fit into the company’s ecosystem or not. </p>

<p>A total of 5 candidates were selected after the technical round and those 5 went on to clear the HR round as well.</p>

<p><strong>What Topics or Skills did the interviewers focus on during the interviews? (e.g., DSA, Puzzles, DBMS, OS, Networks, System Design, or Behavioral questions)</strong><br />
My interview started with problem solving and DSA. The interviewer asked me questions which were easy-medium on the leetcode scale. The questions were based on arrays, strings, hashmaps and heaps. After that I was asked about my knowledge in finance and further asked about the field of sustainable finance.  I was then asked to explain my project and this included cross questioning on how I could apply my projects to solve real world problems faced by the company. I was also asked some conceptual questions on DBMS and OOPs.</p>

<p><strong>What are some good resources that you used in your Internship Prep?</strong><br />
Neetcode 150 DSA playlist<br />
Strivers A2Z<br />
Youtube channels like Gate smashers, Neso, Love Babbar<br />
Geeks for Geeks interview Questions and logic puzzles</p>

<p><strong>Some tips to crack Coding Questions?</strong><br />
Stick to a language you’re comfortable coding in. You do not need to learn a new language to have a code that performs marginally faster right now. Focus on logic building. Be consistent and do problems daily. If you’re stuck on a problem do not immediately give up and look at the solution.</p>

<p><strong>How many questions were asked about Projects, Clubs, and Extracurricular activities in your resume</strong>?<br />
I was asked a decent amount about my extracurriculars in both my technical and HR interview. Most of it was assessed in my HR interview where I was asked about my working with a team, stressful situations that could arise and how I would tackle them.</p>

<p><strong>Is there something specific that you would want to tell people who are preparing for the same company</strong>?<br />
Read up about the company background and the technology they are working on. Interviewers are always impressed when they see you’ve done your homework on the organisation. </p>

<p><strong>Any Final Tips for Juniors?</strong><br />
Trust your preparation, Do not panic both during the test and interview if anything adverse comes your way. Do not bluff about something you don’t know in your interview. Admit you don’t know and express interest in reading about it later.</p>

<p><strong>Contact Info </strong><br />
<strong>Email :</strong> <a href="mailto:anshmehta1357@gmail.com">anshmehta1357@gmail.com</a><br />
<strong>LinkedIn :</strong> <a href="https://www.linkedin.com/in/ansh-mehta-65217a292/"> Ansh Mehta</a></p>

<hr></hr>
        </div>
    )
}

export default ansh_mehta
